"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterFingerprint = exports.isFilterRelevantForFingerprinting = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var filter_1 = require("../filter");
/**
 * Determines if a filter has a semantic effect and thus must be taken into account when computing fingerprints.
 *
 * Irrelevant filters are:
 *
 * -  Measure Value filter with no condition specified
 * -  Negative attribute filter with empty 'notIn' field
 *
 * Note: the ALL_TIME date filter is not treated this way on purpose.
 *
 * @internal
 */
function isFilterRelevantForFingerprinting(filter) {
    if (filter_1.isMeasureValueFilter(filter)) {
        return !!filter.measureValueFilter.condition;
    }
    else if (filter_1.isNegativeAttributeFilter(filter)) {
        return !filter_1.attributeElementsIsEmpty(filter.negativeAttributeFilter.notIn);
    }
    return true;
}
exports.isFilterRelevantForFingerprinting = isFilterRelevantForFingerprinting;
/**
 * Calculates filter fingerprint; ensures that filters that have semantically no effect result in no fingerprint.
 *
 * @remarks see {@link isFilterRelevantForFingerprinting} for information on which filters are considered irrelevant.
 *
 * @internal
 */
function filterFingerprint(filter) {
    return isFilterRelevantForFingerprinting(filter) ? json_stable_stringify_1.default(filter) : undefined;
}
exports.filterFingerprint = filterFingerprint;
//# sourceMappingURL=fingerprint.js.map